import React, { useCallback, useEffect, useState, useRef } from 'react';
import ContentEditable from 'react-contenteditable';

import MenusWrapper from './MenusWrapper';

import { InputWrapper } from './styles';

const InputVoicebotAudioText = ({ name, value, onChange, id }) => {
  const [inputValue, setInputValue] = useState('');

  const inputEditableRef = useRef(null);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handlePlayAudio = (url) => {
    const audio = new Audio(url);
    audio.play();
  };

  const handleUserClick = useCallback((event) => {
    const { target } = event;

    const audioUrl = target.getAttribute('data-audio-url');
    const buttonHasUrlAttribute = target.type === 'button' && audioUrl;

    if (buttonHasUrlAttribute) {
      handlePlayAudio(audioUrl);
    }
  }, []);

  useEffect(() => {
    inputEditableRef.current.addEventListener('click', handleUserClick);

    return () => {
      inputEditableRef.current.removeEventListener('click', handleUserClick);
    };
  }, [inputEditableRef, handleUserClick]);

  const disableNewlines = (event) => {
    const keyCode = event.keyCode || event.which;

    if (keyCode === 13) {
      event.returnValue = false;
      if (event.preventDefault) event.preventDefault();
    }
  };

  const handleInputChange = (e) => {
    const text = e.target.value;

    setInputValue(text);
    onChange({ target: { value: text, name } });
  };

  const handleSelectMenuOption = (audioTag) => {
    const fullText = `${value} ${audioTag}`;

    setInputValue(fullText);
    onChange({ target: { value: fullText, name } });
  };

  return (
    <InputWrapper>
      <MenusWrapper onSelect={handleSelectMenuOption} itemId={id} />

      <ContentEditable
        className="content-editable"
        tagName="div"
        html={inputValue}
        onChange={handleInputChange}
        onKeyPress={disableNewlines}
        innerRef={inputEditableRef}
        id={id}
        name={name}
      />
    </InputWrapper>
  );
};

export default InputVoicebotAudioText;
